export const MARINE_VEHICLE_TYPE = {
    MARINE: 'marine',
};

export const LIST_MARINE_VEHICLE_TYPES = [
    MARINE_VEHICLE_TYPE.MARINE,
];

export const LOS_BOAT_TYPES = {
    PONTOON: "Pontoon",
    POWERBOAT: "Powerboat",
};

export const VEHICLE_TYPE_TO_LOS_BOAT_TYPE = {
    [MARINE_VEHICLE_TYPE.MARINE]: LOS_BOAT_TYPES.POWERBOAT,
};
